import { defineComponent, ref, inject, computed } from 'vue';
import { useLocalizationSupport } from '../../composables/localization-support/index.js';
import { useLogger } from '../../composables/logger/index.js';

var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "UiCopyToClipboard",
  props: {
    locale: { type: null, required: false, default: "en-GB" },
    value: { type: null, required: true },
    copyResultMessagePosition: { type: null, required: false, default: "top" }
  },
  setup(__props) {
    const props = __props;
    const MESSAGE_TIME = 1e3;
    const showSuccessMessage = ref(false);
    const showFailureMessage = ref(false);
    const localizationSupport = useLocalizationSupport(props, {
      translator: inject("translator")
    });
    const { translate } = localizationSupport;
    const copyResultMessageStyle = computed(() => {
      return ["fds-copy-result-message", `fds-copy-result-message--${props.copyResultMessagePosition})`];
    });
    const copyToClipboard = async () => {
      if (!window.navigator.clipboard) {
        failedToCopy("Document copy is not supported");
      } else {
        try {
          await window.navigator.clipboard.writeText(String(props.value));
          successfulCopy();
        } catch (err) {
          failedToCopy(err);
        }
      }
    };
    const successfulCopy = () => {
      showSuccessMessage.value = true;
      setTimeout(() => showSuccessMessage.value = false, MESSAGE_TIME);
    };
    const logger = useLogger();
    const { getLogger } = logger;
    const failedToCopy = (error) => {
      getLogger().error("Unable to copy:", error);
      showFailureMessage.value = true;
      setTimeout(() => showFailureMessage.value = false, MESSAGE_TIME);
    };
    return { __sfc: true, props, MESSAGE_TIME, showSuccessMessage, showFailureMessage, localizationSupport, translate, copyResultMessageStyle, copyToClipboard, successfulCopy, logger, getLogger, failedToCopy };
  }
});

export { _sfc_main as default };
